Ext.ns('mx.Util');

mx.Util.browserDateShift = new Date().getTimezoneOffset() * 60000;

mx.Util.getServerDate = function(epoch) {
    return new Date(epoch + mx.Util.browserDateShift);
};

mx.Util.getClientDate = function(epoch) {
    return new Date(epoch - mx.Util.browserDateShift);
};

mx.Util.getClientDateInDepotTimeZone = function() {
    return application && application.user && application.user.timezone
        ? mx.Util.getServerDate(new Date().getTime() + parseInt(application.user.timezone.offset))
        : new Date();
};

mx.Util.getPreviousSunday = function(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay() - 7);
};
mx.Util.getPreviousMonday = function(d) {
    if (!d.getDay()) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 13);
    }
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay() - 6);
};
mx.Util.displayClientDate = function(date, format) {
    format = format || 'fulldatetime';
    if (date.getTime) {
        return Ext.util.Format.date(mx.Util.getClientDate(date.getTime()), MXBT.getDateFormat(format));
    } else {
        return '';
    }
};
mx.Util.displayDate = function(date, format) {
    format = format || 'fulldatetime';
    if (date.getTime) {
        return Ext.util.Format.date(date, MXBT.getDateFormat(format));
    } else {
        return '';
    }
};
mx.Util.displayServerDate = function(date, format) {
    format = format || 'fulldatetime';
    if (date.getTime) {
        return Ext.util.Format.date(mx.Util.getServerDate(date.getTime()), MXBT.getDateFormat(format));
    } else {
        return '';
    }
};

mx.Util.DateTimeConstants = {
    MSECS_IN_DAY: 24 * 3600 * 1000,
    MSECS_IN_HOUR: 3600 * 1000,
    MSECS_IN_MINUTE: 60 * 1000,
};

mx.Util.qtip = function(v) {
    return '<span ext:qtip="' + v + '">' + v + '</span';
};

/**
 *
 * @param setup [isExportVisible, isImportVisible, expStore, pathString, classesString]
 */
mx.Util.getExportImportBtns = function(setup) {
    var result = [];

    //export button:
    if (setup.isExportVisible) {
        result.push({
            text: mx.comp.PagingToolbar.prototype.labels.exprt,
            iconCls: 'exportbutton',
            handler: function() {
                var items = setup.expStore.query('selected', true);
                var result = [];
                for (var i = 0; i < items.getCount(); i++) {
                    var item = items.get(i);
                    var itemId = item.get('id');
                    if (itemId) {
                        result.push(itemId);
                    }
                }
                window.location.href = setup.pathString + result + setup.classesString;
            },
            scope: this,
        });
    }

    //import button:
    if (setup.isImportVisible) {
        result.push({
            text: mx.comp.PagingToolbar.prototype.labels.imprt,
            iconCls: 'importbutton',
            handler: function() {
                new mx.app.widget.Import({
                    store: null,
                    loadOrders: null,
                    loadResources: null,
                    urlString: mx.PATH + MXAT.API('file/import_data/'),
                }).show();
            },
        });
    }

    return result;
};
